import React from 'react';
import { X, AlertTriangle, Trash2 } from 'lucide-react';

const ConsultationDeleteModal = ({ consultation, isOpen, onClose, onConfirm, loading }) => {
  if (!isOpen || !consultation) return null;

  const handleConfirm = () => {
    onConfirm(consultation.id);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-red-100 rounded-full">
              <AlertTriangle className="h-6 w-6 text-red-600" />
            </div>
            <h2 className="text-xl font-bold text-gray-900">Confirmer la suppression</h2>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full" disabled={loading}>
            <X className="h-6 w-6 text-gray-500" />
          </button>
        </div>

        <div className="p-6">
          <p className="text-gray-700 mb-4">
            Êtes-vous sûr de vouloir supprimer la consultation du patient <strong>{consultation.patient?.name || 'Patient inconnu'}</strong> du {new Date(consultation.consultationDate).toLocaleDateString('fr-FR')} ?
          </p>
          <p className="text-sm text-gray-500">
            Cette action est irréversible. Toutes les données de la consultation seront supprimées.
          </p>
        </div>

        <div className="px-6 py-4 border-t border-gray-200 flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
            disabled={loading}
          >
            Annuler
          </button>
          <button
            onClick={handleConfirm}
            disabled={loading}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center space-x-2 disabled:opacity-50"
          >
            <Trash2 className="h-4 w-4" />
            <span>{loading ? 'Suppression...' : 'Supprimer'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsultationDeleteModal;
